import fetch from "../auth/GenericFetchInterceptorV5";

// Service per la gestione dei DDT
const DdtService = {

    async list(companyId) {
        const res = await fetch({
            url: `/api/ddts?passive=true&companyDocumentId=${encodeURIComponent(companyId)}`,
            method: 'GET',
        })
        return {data: res.data};
    },
    async create(data, companyId) {
        if (data?.type === 'REPAIR_DISPATCH') {
            return fetch({url: '/api/ddts/create/repair-dispatch', method: 'POST',
                data: {...data, companyDocumentId: companyId}});
        }
        if (data?.type === 'SUPPLIER_RETURN') {
            return fetch({url: '/api/ddts/create/supplier-return', method: 'POST',
                data: {...data, companyDocumentId: companyId}});
        }
        const manualReferenceCode = data?.manualReferenceCode || data?.referenceCode || data?.manual_reference_code || data?.ddtName || data?.name || '';
        const manualReferenceQuery = manualReferenceCode
            ? `&manualReferenceCode=${encodeURIComponent(manualReferenceCode)}`
            : '';
        return fetch({
            url: `/api/ddts/create/supplier-ddt?companyId=${companyId}${manualReferenceQuery}`,
            method: 'POST',
            data: data
        })
    },
    async createMds(data, companyId) {
        return fetch({
            url: `/api/ddts/create/mds-ddt?companyId=${companyId}`,
            method: 'POST',
            data: data
        })
    },
    async supplierReturnLots({companyDocumentId, supplierDocumentId}) {
        const query = new URLSearchParams({companyDocumentId, supplierDocumentId});
        return fetch({url: `/api/ddts/supplier-return/eligible-lots?${query}`, method: 'GET'});
    },
    async repairDispatchLots({companyDocumentId, ddtDocumentId}) {
        const query = new URLSearchParams({companyDocumentId});
        if (ddtDocumentId) query.set('ddtDocumentId', ddtDocumentId);
        return fetch({url: `/api/ddts/repair-dispatch/eligible-lots?${query}`, method: 'GET'});
    },
    async updateRepairDispatch(documentId, data) {
        return fetch({url: `/api/ddts/update/repair-dispatch/${encodeURIComponent(documentId)}`, method: 'PUT', data});
    },
    // Nuovo: dettaglio DDT con populate completo (lots, product, warehouse_articles.storage, supplier)
    async getByDocumentIdAll(documentId) {
        return fetch({
            url: `/api/ddts/${encodeURIComponent(documentId)}?passive=true`,
            method: 'GET'
        })
    },
    // Nuovo: azione di riparazione su lotto associato a DDT
    async repairLot({ ddtDocumentId, lotDocumentId, newSerial, reason }) {
        return fetch({
            url: `/api/ddts/repair/repair-lots`,
            method: 'POST',
            data: { ddtDocumentId, lotDocumentId, newSerial, reason }
        })
    },
    // Nuovo: riparazione multipla di lotti in una singola chiamata
    async repairLotsBulk({ ddtDocumentId, ddtId, ddtReferenceCode, repairs }) {
        return fetch({
            url: `/api/ddts/repair/repair-lots`,
            method: 'POST',
            data: { ddtDocumentId, ddtId, ddtReferenceCode, repairs }
        })
    },
    // Modifica di una bolla fornitore aperta: header, lotti (modifica/rimozione) e nuovi articoli
    async updateSupplierDdt(documentId, data) {
        return fetch({
            url: `/api/ddts/update/supplier-ddt/${encodeURIComponent(documentId)}`,
            method: 'PUT',
            data: data
        })
    },
    // Aggiorna DDT (es. per salvare note)
    async update(documentId, data) {
        return fetch({
            url: `/api/ddts/${documentId}`,
            method: 'PUT',
            data: data
        })
    },
};

export default DdtService;
